/**
 * Safety Meeting API Service
 * Handles API requests related to safety meeting PDFs
 */

import { apiRequest } from "./axios";
import { API_PATHS, LANGUAGE_CONFIG } from "../../config";

/**
 * Fetches the safety meeting PDF for a given week
 *
 * @param {string} weekEnd - The week ending date in YYYY-MM-DD format
 * @param {string} language - Preferred-language code. Defaults to the configured default.
 * @returns {Promise<Blob>} PDF blob object
 */
export async function getSafetyMeetingPDF(weekEnd, language = LANGUAGE_CONFIG.DEFAULT) {
  try {
    const response = await apiRequest(
      API_PATHS.SAFETYMEETING.GET_PDF,
      {
        week_ending: weekEnd,
        language: language,
      },
      {
        method: "POST",
        responseType: "blob", // Important: tells axios to expect binary data
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching safety meeting PDF:", error);
    throw error;
  }
}

/**
 * Fetches all safety meeting topics with crew data
 *
 * @returns {Promise<Array>} Array of meeting topic objects
 */
export async function getMeetingTopics() {
  try {
    const response = await apiRequest(
      API_PATHS.SAFETYMEETING.TOPICS,
      null,
      { method: "GET" }
    );
    return response;
  } catch (error) {
    console.error("Error fetching meeting topics:", error);
    throw error;
  }
}
